﻿import { Component, Attribute, Input, Output, IComponent, Inject } from "@fiqas/angular-utils";
import { FIQAssist } from "../../app";
import { ServiceCaseService } from "../../services/fiqassistApi/serviceCaseService"
import { TranslationService } from "../../services/TranslationService"
import { CaseFileData } from "../../models/file";

@Component({
    module: FIQAssist,
    selector: 'statusbuttons',
    template: `<div class="statusbuttons">
                <div ng-repeat="button in $ctrl.buttons" class="statusbutton">
                    <pushbutton
                        class="{{button.name}}"
                        isdisabled="$ctrl.readOnly"
                        tooltip-append-to-body="true" tooltip-placement="bottom"  tooltip-class="customTooltipTB" uib-tooltip="{{$ctrl.tooltip(button.tooltipname)}}"
                        buttontext="{{button.name | translate}}"
                        onclicked="$ctrl.handleStatus(button.id)"></pushbutton>
                </div>
            </div>`
})
export class StatusButtons {
    @Input() public readOnly: boolean;
    @Input() public buttons: StatusButton[];
    @Output() public onstatus: (args: { status: string }) => void;

    constructor(
        @Inject() private translationService: TranslationService
    ) { }

    public tooltip(name: string) {
        return this.translationService.Translate("CHANGE_STATUS_TO_0").replace("0", this.translationService.Translate(name.toUpperCase()))
    }

    private handleStatus(status: string) {
        this.onstatus({ status: status });
    }
}

export interface StatusButton {
    name: string;
    id: any;
    tooltipname: string;
}

